import {
  Building2,
  CheckCircle2,
  KeyRound,
  LogOut,
  Mail,
  MonitorSmartphone,
  ShieldCheck,
  UserRound,
} from "lucide-react";
import { useProfileSessionsWorkspace } from "./useProfileSessionsWorkspace";
import { roleLabels, formatDate, deviceLabel } from "./profile-presentation";
import type { SessionUser } from "../../shared/auth/access";

export function ProfileModule({
  user,
  notify,
}: {
  user: SessionUser;
  notify: (message: string) => void;
}) {
  const { sessions, loadSessions, revoke, revoking } = useProfileSessionsWorkspace({user,notify});

  return (
    <>
      <div className="module-header">
        <div>
          <span className="section-kicker">Hesap ve güvenlik</span>
          <h1>Profilim</h1>
          <p>
            Kurumsal kimliğinizi, uygulama rollerinizi ve aktif oturumlarınızı
            görüntüleyin.
          </p>
        </div>
      </div>

      <section className="profile-layout">
        <article className="profile-card identity-card">
          <div className="profile-avatar">{user.initials}</div>
          <div>
            <span className="admin-state is-success">
              <CheckCircle2 size={12} /> Microsoft hesabı bağlı
            </span>
            <h2>{user.name}</h2>
            <p>{user.title}</p>
          </div>
        </article>

        <article className="profile-card">
          <h2>Kurumsal bilgiler</h2>
          <dl className="profile-facts">
            <div>
              <dt>
                <Mail size={15} /> E-posta
              </dt>
              <dd>{user.email}</dd>
            </div>
            <div>
              <dt>
                <Building2 size={15} /> Departman
              </dt>
              <dd>{user.department}</dd>
            </div>
            <div>
              <dt>
                <UserRound size={15} /> Ünvan
              </dt>
              <dd>{user.title}</dd>
            </div>
            <div>
              <dt>
                <KeyRound size={15} /> Roller
              </dt>
              <dd>
                {user.assignedRoles.map((role) => roleLabels[role]).join(", ")}
              </dd>
            </div>
          </dl>
          <div className="profile-lock-note">
            <ShieldCheck size={16} />
            Rol, departman ve hesap durumu yalnızca Sistem Yöneticisi tarafından
            değiştirilebilir.
          </div>
        </article>

        <article className="profile-card">
          <h2>Bildirim tercihleri</h2>
          <div className="profile-preference">
            <div>
              <strong>Satın alma süreç bildirimleri</strong>
              <small>Rolünüzle ilgili işlem ve karar değişiklikleri</small>
            </div>
            <span>Kurumsal e-posta</span>
          </div>
          <div className="profile-preference">
            <div>
              <strong>Güvenlik bildirimleri</strong>
              <small>Yeni oturum ve erişim değişiklikleri</small>
            </div>
            <span>Zorunlu</span>
          </div>
        </article>
      </section>

      <section className="module-card">
        <div className="section-heading">
          <div>
            <span className="section-kicker">Oturum güvenliği</span>
            <h2>Aktif uygulama oturumlarım</h2>
          </div>
          <button className="text-button" onClick={loadSessions}>
            Yenile
          </button>
        </div>
        {sessions.length ? (
          <div className="profile-session-list">
            {sessions.map((session) => (
              <article key={session.id}>
                <span className="profile-session-icon">
                  <MonitorSmartphone size={18} />
                </span>
                <div>
                  <strong>
                    {deviceLabel(session.user_agent)}
                    {session.current ? " · Bu cihaz" : ""}
                  </strong>
                  <small>
                    Son etkinlik {formatDate(session.last_seen_at)} · Bitiş{" "}
                    {formatDate(session.expires_at)}
                  </small>
                </div>
                <button
                  className="row-action danger"
                  disabled={session.current || revoking.includes(session.id)}
                  onClick={() => revoke(session)}
                >
                  <LogOut size={14} /> Sonlandır
                </button>
              </article>
            ))}
          </div>
        ) : (
          <div className="module-empty">
            <MonitorSmartphone size={28} />
            <strong>Aktif oturum bulunmuyor</strong>
            <p>Geçerli oturum bilgisi alınamadı veya oturum süresi doldu.</p>
          </div>
        )}
      </section>
    </>
  );
}
